import React from "react";
import PropTypes from "prop-types";
import { useFormikContext, getIn } from "formik";
import { TextField, GroupField, ArrayField, FieldLabel } from "react-invenio-forms";
import { Button, Form, Icon } from "semantic-ui-react";
import { CustomArrayField } from "./CustomArrayField";

// Default value for new line
export const emptyMultiLineValue = {
  value: "",  // Default empty value for the line
};

const MultiLineInput = ({
  fieldPath,
  label,
  placeholder,
  description,
  additionLabel,
  icon,
  required,
}) => {
  const { values } = useFormikContext(); // Now you can use the hook

  // Helper function to extract the current value for each line
  const getValueForLine = (indexPath) => {
    const currentValue = getIn(values, fieldPath, []);
    return typeof currentValue[indexPath] === "object" ? "" : currentValue[indexPath];
  };

  return (
    <>
      <CustomArrayField
        addButtonLabel={additionLabel || "Add Line"} // Default label
        defaultNewValue={""} // Default empty value for new lines
        fieldPath={fieldPath}
        label={<FieldLabel htmlFor={fieldPath} icon={icon} label={label} />}
        required={required}
      >
        {({ arrayHelpers, indexPath, formikProps }) => {
          const fieldPathPrefix = `${fieldPath}.${indexPath}`;
          // Get the current value for the field
          const lineValue = getValueForLine(indexPath);
          return (
            <GroupField key={fieldPathPrefix} optimized>
              <TextField
                fieldPath={`${fieldPathPrefix}`} // Bind to 'value'
                label={label}
                required={required}
                placeholder={placeholder}
                value={lineValue} // Display the current value
                width={16}
              />
              <Form.Field>
                <Button
                  aria-label="Remove line"
                  className="close-btn"
                  icon
                  onClick={() => arrayHelpers.remove(indexPath)}
                >
                  <Icon name="close" />
                </Button>
              </Form.Field>
            </GroupField>
          );
        }}
      </CustomArrayField>

      {/* Check if description is passed */}
      {description && <label className="helptext">{description}</label>}
    </>
  );
}


MultiLineInput.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  description: PropTypes.string,
  additionLabel: PropTypes.string,
  icon: PropTypes.string,
  required: PropTypes.bool,
};

MultiLineInput.defaultProps = {
  additionLabel: "Add Line", // Default add button label
  icon: undefined,
  required: false,
  description: undefined,
};

export default MultiLineInput;
